import { useQuery } from '@tanstack/react-query'
import { webPageService } from '@/lib/api/services/web-pages'

// Query keys for web pages management
export const webPagesKeys = {
  all: ['web-pages'] as const,
  allWebPages: () => [...webPagesKeys.all, 'allWebPages'] as const,
  webPage: (id: string) => [...webPagesKeys.allWebPages(), id] as const,
  webPagesPaginated: () =>
    [...webPagesKeys.allWebPages(), 'paginated'] as const,
  webPagesAll: () => [...webPagesKeys.allWebPages(), 'all'] as const,
  webPagesSearch: (query: string) => [...webPagesKeys.allWebPages(), 'search', query] as const
}

/**
 * Get all web pages (unpaginated)
 */
export const useAllWebPages = () => {
  return useQuery({
    queryKey: webPagesKeys.webPagesAll(),
    queryFn: () => webPageService.getAllWebPages(),
    staleTime: 5 * 60 * 1000 // 5 minutes
  })
}


/**
 * Get web page by ID
 */
export const useWebPage = (webPageId: string) => {
  return useQuery({
    queryKey: webPagesKeys.webPage(webPageId),
    queryFn: () => webPageService.getWebPageById(webPageId),
    enabled: !!webPageId,
    staleTime: 5 * 60 * 1000 // 5 minutes
  })
}

